// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpTabsHero-cls1_zRV","cls2":"LoswpTabsHero-cls2_SIr LoswpTabsHero-cls1_zRV"};